import {AssetLien} from './asset-lien.model';
import {SellerLocation} from './sellerLocation.model';
import {AuditAssetMove} from './audit-asset-move.model';
import {E_RESERVE, MAKE_OFFER, RBA_LIVE, BUY_NOW, SELLER_BID_SELECT} from './asset-sale-type';
import {IRONPLANET, TRUCKPLANET, GOVPLANET, SALVAGESALE} from './asset-platform';
import {AssetIssue} from './asset-issue.model';
import {appConfig} from '../../app.config';
import {Site} from '../site';
import {Address, Contact} from '@rbaip/address-form';
import {ASSET_ISSUE_DUPLICATED_SELLER_REF_ID, ASSET_ISSUE_DUPLICATED_SERIAL_NUMBER_ID} from './asset-issue-type';
import {AssetSellingDetails} from './asset-selling-details.model';

export class Asset {
  assetId: number;
  categoryId: any;
  typeId: number;
  usageTypeId: number;
  modelId: number;
  modelName: string;
  manufacturerId: number;
  manufacturerName: string;
  manufacturingYear: any;
  serialNumber: string;
  usageQuantity: number;
  sellerTrackingCode: string;
  featuresText: string;
  featuresJson: string;
  catalogText: string;
  catalogJson: string;
  woId: number;
  checkListId: number;
  assetControlGroupId: number;
  customDescrTxt: string;
  translatedDescr: string;
  categoryName: string;
  usage: string;
  usageTypeName: string;
  shootPrice: number;
  tmShootPrice: number;
  forcedConsensusValue: number;
  algoPriceAmt: number;
  locationId: number;
  storageLocationName: string;
  storageLocationCity: string;
  storageLocationProv: string;
  licensePlate: string;
  condition: string;
  auctionEventId: number;
  saleType: string;
  inspectionType: string;
  yardDeliveyDt: Date;
  rnrBudget: number;
  haulingBudget: number;
  resvPriceAmt: number;
  sellerReserveAmt: number;
  listFeeAmt: number;
  strikePriceAmt: number;
  notifyPriceAmt: number;
  brochurePhoto: string;
  internalNotes: string;
  dataEntryStatus: string;
  modifiedDt: Date = new Date();
  createDt: Date = new Date();
  lastModifierId: number;
  year: string;
  equipId: number;
  assetStatusId: any;
  assetstatus: string;
  assetLiens: Array<AssetLien> = [];
  assetLocationDto: SellerLocation;
  auctionSite: boolean;
  siteAddress: Address;
  setDefault: boolean;
  siteId: number;
  selectedSite: Site;
  createdFromAPI: boolean = false;
  addAssetLien:boolean = false;
  assetStatusName: string;
  currencyCode: string;
  estimatedMarketValue: number; // future integration with another algorithm in PPS when Shoot Price is not available
  marketValue: number; // comes from PPS
  realmId: number;
  conditionName: string;
  saleTypeName: string;
  assetGuid: number;
  media?: { photos: { lowResImageUrl: string, highResImageUrl: string }[] };
  terrId: number;
  terrManangerName: string;
  typeName: string;
  highlight: boolean = false;
  ceMarkings: string;
  epaMarkings: string;
  numberOfTitles: number;
  engineNum: string;

  ownerCode: string;
  lotNumberStr: string;
  sellerId: number;
  sellerCompanyName: string;
  sellerContact: string;
  sellerTelephone: string;
  buyerPaddleId: number;
  soldPrice: any;
  scheduleA: number;
  scheduleAModifier: string;
  inspectorName: string;
  titleStatus: string;
  aucEndDate: Date = new Date();
  keyNumber: string;
  unUsed: string;
  kittedYn: string;
  glidered: string;
  bondedYn: string;
  rebuildableYN: string;
  salvagedYN: string;
  rebuiltYN: string;
  titleBillOfSale: string;
  color: string;
  isWarrantyEligible: boolean = false;
  offSite = false;
  sellingMethod: string;
  vinVerified: string;
  prevEndDt: Date = new Date();
  titleHeldTrust: boolean = false;
  fuelType: string;
  bodyType: string;
  numOfCylinders: string;
  titleValueNumofAxle: number;
  numOfAxle: string;
  titleValue: any;
  grossVehicleEmptyWeight: any;
  grossVehicleCarryingWeight: any;
  contractType: string;
  vinLocation: string;
  equipmentInYard: boolean;
  ownerBookNotes: string;
  sellerContractNumber: string;
  contractNotes: string;
  assetState:string="None";
  unusedYn: boolean;
  inoperableYn: boolean;
  partsOnlyYn: boolean;
  glideredYn: boolean;
  auditAssetMove: AuditAssetMove;
  tiresUndercarriageRating: string;
  photoCount: number;
  lienYn: boolean;
  serialNumberPhotoUrls: string[];
  meterReadingPhotoUrls: string[];
  serialNumberPhotoUrl: string;
  meterReadingPhotoUrl: string;
  serialNumberLocation:string;
  serialNumVerified: string;
  talLot: boolean;
  talClosingDate: Date;
  duplicateSerialNumber: boolean;
  duplicateSellerTrackingCode: boolean;
  preSale: boolean;
  inAuction: boolean;
  postSale: boolean;
  notSold: boolean;
  checkedOutDate: Date;
  buyerDisplayName: string;
  titleStatusDescription: string;
  isCheckedIn: boolean;
  parentComponent: Asset;
  parentComponentLot: boolean;
  childComponentLot: boolean;
  components: Asset[];
  legalContact: Contact;
  contractConfidential: boolean;
  equipmentContacts: Contact[];
  legalContactId: number;
  equipmentStatus: number;
  equipmentStatusName: string;
  auctionEventName: string;
  saleNumber: string;
  assetControlGroupName: string;
  channel: string;
  inspectionStatusCode: string;
  lotNumber: number;
  postModelDescription: string;
  descriptionEditable: boolean;
  preview: boolean;
  buyerContact: Contact;
  entityId: number;
  platformName: string;
  issues: AssetIssue[] = [];
  issueDesc: string;
  customRowCssClass: string;
  sortOrder: number;
  comesWith: string;
  appraisalDescription: string;
  appraisalFeatures: string;
  opportunityLegalAccountName: string;
  revealResvYn: boolean = false;
  notifySellerYn: boolean = false;
  showMakeOfferYn: boolean = true;
  showBuyNowYn: boolean = true;
  rejectPriceAmt: number;
  vso: boolean;
  cleanBudget: number;
  sandBlastAndPaintBudget: number;
  upholsteryBudget: number;
  glassBudget: number;
  tiresUndercarriageBudget: number;
  bodyWorkBudget: number;
  mechanicalBudget: number;
  deIdentifyBudget: number;
  miscBudget: number;
  repairRefurbId: number;
  contractStatus: string;
  contractSignedYn = false;
  atRiskPackageAsset = false;
  titleLiensStat: string;
  auctionStatus: string;
  titleYn: string;
  currentPackageName : string;
  movedDate : Date;
  userName: string;
  doNotAdvertise: boolean;
  hasTitle: boolean;
  destinationEquipmentId: number;
  reviewedBySalesCoordinator:boolean;
  assetPackageStatusId: number;
  pulledFromAuctionEventId: number;
  pulledFromAuctionStartDate: Date;
  pulledFromAuctionEventName: string;
  contractRecordType: string;
  previousAuctionSaleType:string;
  sequenced: boolean = false;
  duplicateSerialNumberAssets:number[];
  duplicateSellerRefNumberAssets:number[];
  sellingDetails?: AssetSellingDetails;
  hasPotentialIssue: boolean = false;
  hasMajorIssues: boolean = false;
  lotNumberModifier: string;
  appraisalLocationId: number;
  appraisalLocationName: string;
  appraisalLocationDto: SellerLocation;
  inspGroupId: number;
  inspCntctId: number;
  inspStatus: string;
  inspSchedDt: Date;
  channelMismatchYn: boolean;
  mergeCheckList: boolean;
  deleteReason: string;
  deleteReasonExplanation: string;
  isEditContact: boolean = false;
  diagnostics: string;

  public static constructFromSearchListJson(objectListJson: any[]): Asset[] {
    const searchList: Asset[] = [];

    if (!objectListJson) {
      return searchList;
    }

    // const dateFormatPipe = new DateFormatPipe();
    for (const objectJson of objectListJson) {
      const itemDto: Asset = Asset.constructFromObjectJson(objectJson);
      // itemDto.createdDateTime = dateFormatPipe.transform(itemDto.createdTimestamp);
      // itemDto.resolvedDateTime = dateFormatPipe.transform(itemDto.resolvedTimestamp);
      searchList.push(itemDto);
    }

    return searchList;
  }

  public static constructFromObjectJson(objectJson: any): Asset {
    const asset: Asset = Object.assign(new Asset(), objectJson);
    asset.brochurePhoto = Asset.constructBrochurePhotoUrl(asset.brochurePhoto, asset.saleType);
    if (asset.parentComponent) {
      asset.parentComponent.brochurePhoto = Asset.constructBrochurePhotoUrl(asset.parentComponent.brochurePhoto, asset.parentComponent.saleType);
    }
    if (asset.components && asset.components.length > 0) {
      for (let i = 0; i < asset.components.length; i++) {
        asset.components[i].brochurePhoto = Asset.constructBrochurePhotoUrl(asset.components[i].brochurePhoto, asset.components[i].saleType);
      }
    }

    if (asset.yardDeliveyDt) {
      asset.yardDeliveyDt = asset.yardDeliveyDt ? new Date(asset.yardDeliveyDt) : null;
    }

    asset.updatePhotoLinksWithHighResolutionPhotos();
    asset.prepareContractContacts();
    asset.assignCustomClass();
    return asset;
  }

  public static constructBrochurePhotoUrl(brochurePhotoPath: string, saleType: string): string {
    const isBrochurePhotoPathValid = !!brochurePhotoPath;
    let defaultPhotoUrl = appConfig.defaultPhotoUrlForNonPhotoItem;
    if (saleType && saleType === 'LIVE') {
      defaultPhotoUrl = appConfig.defaultPhotoUrlForNonPhotoRBItem;
    }
    return isBrochurePhotoPathValid
      ? (brochurePhotoPath.startsWith('http') ? brochurePhotoPath : appConfig.getPublicImageHost() + brochurePhotoPath)
      : defaultPhotoUrl;
  }

  public static isRBRealm(asset: Asset): boolean {
    return asset && [61, 62, 63, 64, 65, 66, 67, 68, 69].indexOf(asset.realmId) > -1;
  }

  public getDescriptionWithSerialNumber(): string {

    return this.customDescrTxt + (this.serialNumber ? ' - ' + this.serialNumber : '');
  }

  private updatePhotoLinksWithHighResolutionPhotos() {
    // change to use 1920x1440 photo for serial# and meter reading photo
    if (this.meterReadingPhotoUrls && this.meterReadingPhotoUrls.length > 0) {
      this.meterReadingPhotoUrl = this.meterReadingPhotoUrls[0].replace('/400x300/', '/1920x1440/');
    }
    if (this.serialNumberPhotoUrls && this.serialNumberPhotoUrls.length > 0) {
      this.serialNumberPhotoUrl = this.serialNumberPhotoUrls[0].replace('/400x300/', '/1920x1440/');
    }
  }

  public prepareContractContacts() {
    const NUMBER_OF_ALLOWED_EQUIPMENT_CONTACTS = 2;
    if (this.equipmentContacts) {
      this.equipmentContacts = this.equipmentContacts.map(equipmentContactJson => Contact.fromJsonString(equipmentContactJson));
      const numberOfEmptyContractContacts = NUMBER_OF_ALLOWED_EQUIPMENT_CONTACTS - this.equipmentContacts.length;
      for (let i = 0; i < numberOfEmptyContractContacts; i++) {
        this.equipmentContacts.push(new Contact());
      }
    } else {
      this.equipmentContacts = [];
    }
  }

  public isPreContractAsset(): boolean {
    let response = true;
    if (this.equipId) {
      response = false;
    }
    return response;
  }

  public isPostContractAsset(): boolean {
    let response = false;
    if (this.equipId) {
      response = true;
    }
    return response;
  }

  public isRBAsset(): boolean {
    let response = false;
    if (Asset.isRBRealm(this)) {
      response = true;
    }
    return response;
  }

  public isIPAsset(): boolean {
    let response = false;
    if ( !this.isRBAsset() && ( this.platformName === IRONPLANET || this.platformName === TRUCKPLANET ) && !this.isMPEAsset() ) {
      response = true;
    }
    return response;
  }

  public isGOVAsset(): boolean {
    let response = false;
    if ( this.saleType !== RBA_LIVE && this.platformName === GOVPLANET) {
      response = true;
    }
    return response;
  }

  public isSalvageSaleAsset(): boolean {
    let response = false;
    if ( this.platformName === SALVAGESALE) {
      response = true;
    }
    return response;
  }

  public isMPEAsset(): boolean {
    let response = false;
    if ( !this.isRBAsset()  && this.saleType === E_RESERVE || this.saleType === BUY_NOW || this.saleType === MAKE_OFFER || this.saleType === SELLER_BID_SELECT ) {
      response = true;
    }
    return response;
  }

  public getRBLink(rbItemInfo: any): string {
    let link : string = '';
    if (rbItemInfo && rbItemInfo._links && rbItemInfo._links.seo) {
      link = rbItemInfo._links.seo.href;
    }
    return link;
  }

  public getRBErrorMessage(rbItemInfo: any): string {
    let errorMessage : string = 'Item information is not available';
    if (rbItemInfo && rbItemInfo.errors) {
      errorMessage = rbItemInfo.errors[0].code + ' ' + rbItemInfo.errors[0].message;
    }
    return errorMessage;
  }

  public getIPLink(): string {
    let link : string = '';
    if (this.equipId) {
      link = appConfig.getIronPlanetPageUrl() + appConfig.ironPlanetItemInfoHref + this.equipId.toString()+'?do=1';
    }
    return link;
  }

  public getGOVLink(): string {
    let link : string = '';
    if ( this.equipId ) {
      link = appConfig.getGovPlanetPageUrl() + appConfig.ironPlanetItemInfoHref + this.equipId.toString() + '?do=1';
    }
    return link;
  }

  public getSalvageSaleLink(): string {
    let link = '';
    if ( this.equipId ) {
      link = appConfig.getSalvageSalePageUrl() + appConfig.ironPlanetItemInfoHref + this.equipId.toString() + '?do=1';
    }
    return link;
  }

  public getNumberOfIssues(): number {
    return (this.issues) ? this.issues.length : 0;
  }

  public getIssueShortNames(): string {
    const shortNames: string[] = [];
    if (this.issues) {
      this.issues.forEach(issue => {
        shortNames.push(issue.shortName);
      });
    }
    return shortNames.join(', ');
  }

  public getIssueNames(): string {
    const names: string[] = [];
    if ( this.issues ) {
      this.issues.forEach(issue => {
        let issueName = " ";
        if(issue.issueType === ASSET_ISSUE_DUPLICATED_SERIAL_NUMBER_ID){
          var assetLinks='';
          if(this.duplicateSerialNumberAssets){
            this.duplicateSerialNumberAssets.forEach( assetId => {
              assetLinks += '<a href=\'' + appConfig.assetManagementPortalRoot + '\/opportunity/asset-packages\/'+ this.assetControlGroupId + '\/assets\/' +assetId+ '/summary\' target="_blank">' + assetId+ '</a>,'
            })
          }
          if(assetLinks.endsWith(',')){
            assetLinks = assetLinks.substr(0, assetLinks.length-1);

          }
          issueName = '* ' + issue.name + ' with Asset ID: ' + assetLinks + '<br>';
        } else if(issue.issueType === ASSET_ISSUE_DUPLICATED_SELLER_REF_ID){
          var assetLinks='';
          if(this.duplicateSellerRefNumberAssets){
            this.duplicateSellerRefNumberAssets.forEach( assetId => {
              assetLinks += '<a href=\'' + appConfig.assetManagementPortalRoot + '\/opportunity/asset-packages\/'+ this.assetControlGroupId + '\/assets\/' +assetId+ '/summary\' target="_blank">' + assetId+ '</a>,'
            })
          }
          if(assetLinks.endsWith(',')){
            assetLinks = assetLinks.substr(0, assetLinks.length-1);
          }
          issueName = '* ' + issue.name + ' with Asset ID: ' + assetLinks + '<br>';
        } else {
          issueName = '* ' + issue.name + '<br>';
        }
        names.push(issueName);
      });
    }
    return names.join('');
  }

  public getMajorIssueNames(): string {
    const names: string[] = [];
    if ( this.issues ) {
      this.issues.forEach(issue => {
        let issueName = " ";
        if(issue.issueType !== ASSET_ISSUE_DUPLICATED_SERIAL_NUMBER_ID && issue.issueType !== ASSET_ISSUE_DUPLICATED_SELLER_REF_ID){
          issueName = '* ' + issue.name + '<br>';
        }
        names.push(issueName);
      });
    }
    return names.join('');
  }

  public getPotentialIssueNames(): string {
    const names: string[] = [];
    if ( this.issues ) {
      this.issues.forEach(issue => {
        let issueName = " ";
        if(issue.issueType === ASSET_ISSUE_DUPLICATED_SERIAL_NUMBER_ID){
          var assetLinks='';
          if(this.duplicateSerialNumberAssets){
            this.duplicateSerialNumberAssets.forEach( assetId => {
              assetLinks += '<a href=\'' + appConfig.assetManagementPortalRoot + '\/opportunity/asset-packages\/'+ this.assetControlGroupId + '\/assets\/' +assetId+ '/summary\' target="_blank">' + assetId+ '</a>,'
            })
          }
          if(assetLinks.endsWith(',')){
            assetLinks = assetLinks.substr(0, assetLinks.length-1);

          }
          issueName = '* ' + issue.name + ' with Asset ID: ' + assetLinks + '<br>';
        } else if(issue.issueType === ASSET_ISSUE_DUPLICATED_SELLER_REF_ID){
          var assetLinks='';
          if(this.duplicateSellerRefNumberAssets){
            this.duplicateSellerRefNumberAssets.forEach( assetId => {
              assetLinks += '<a href=\'' + appConfig.assetManagementPortalRoot + '\/opportunity/asset-packages\/'+ this.assetControlGroupId + '\/assets\/' +assetId+ '/summary\' target="_blank">' + assetId+ '</a>,'
            })
          }
          if(assetLinks.endsWith(',')){
            assetLinks = assetLinks.substr(0, assetLinks.length-1);
          }
          issueName = '* ' + issue.name + ' with Asset ID: ' + assetLinks + '<br>';
        }
        names.push(issueName);
      });
    }
    return names.join('');
  }

  private assignCustomClass(): void {
    this.customRowCssClass = '';
    if ( this.getNumberOfIssues() > 0 ) {
      if ( this.hasHoldIssues() ) {
        this.customRowCssClass = 'dt-red-issue-row';
      } else {
        this.customRowCssClass = 'dt-yellow-issue-row';
      }
    }
  }

  private hasHoldIssues(): boolean {
    let filteredIssues: AssetIssue[] = [];
    if ( this.issues ) {
      filteredIssues = this.issues.filter( issue => issue.issueType != ASSET_ISSUE_DUPLICATED_SERIAL_NUMBER_ID &&  issue.issueType != ASSET_ISSUE_DUPLICATED_SELLER_REF_ID );
    }
    return 0 != filteredIssues.length;
  }

  public isYomVerified(): boolean {
    return this.serialNumVerified === 'Y' ||  this.serialNumVerified === 'U' ||  this.serialNumVerified === 'R';
  }

  public getEventDashboardUrl() {
    return appConfig.getEventDashboardUrl(this.siteId, this.auctionEventId);
  }

  public static isPendingAppraisal(asset: Asset): boolean {
    return !asset.equipId && !!asset.inspGroupId && asset.inspStatus !== 'Complete';
  }

  public getAssetOrigin() : SellerLocation {
    return !!this.appraisalLocationDto ? this.appraisalLocationDto : this.assetLocationDto;
  }

}
